<template>
  <div>
  <div class="d-flex">
    <h2 class="small-title">
      Statistiques de votre établissement
      <span class="text-small text-muted text">(Hors avis impossible)</span>
    </h2>
  </div>
  <div class="mb-5">
    <div class="row g-2">
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="h-100 row g-0 card-body align-items-center">
            <div class="col-auto">
              <div class="sw-6 sh-6 d-flex justify-content-center align-items-center border border-dark rounded-xl">
                <div class="cta-2">{{establishment.stats_average_mark}}<small>/10</small></div>
              </div>
              
            </div>
            <div class="col sh-6 ps-3 d-flex flex-column justify-content-center">
              <div class="heading mb-0 d-flex align-items-center">Note moyenne</div>
              <div class="text-small text-muted text">TOUTES PLATEFORMES CONFONDUES</div>
            </div>
            <div class="progress progress-lg mt-4">
              <progress class="progress" :value="establishment.stats_average_mark" max="10">15%</progress>
            </div>
          </div>
          
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="h-100 row g-0 card-body align-items-center">
            <div class="col-auto">
              <div class="sw-6 sh-6 d-flex justify-content-center align-items-center border border-dark rounded-xl">
                <div class="cta-2">
                  {{establishment.nb_negative}}
                  <div style="display:none;">{{establishment.nb_positive}}</div>
                </div>
              </div>
              
            </div>
            <div class="col sh-6 ps-3 d-flex flex-column justify-content-center">
              <div class="heading mb-0 d-flex align-items-center">Avis négatifs</div>
              <div class="text-small text-muted text">NOTE INF. 7/10 SUR LES 30 DERNIERS JOURS</div>
            </div>
            <div class="progress progress-lg mt-4">
              <progress class="progress" :value="100 - satisfaction" max="100">15%</progress>
            </div>
          </div>
          
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="h-100 row g-0 card-body align-items-center">
            <div class="col-auto">
              <div class="sw-6 sh-6 d-flex justify-content-center align-items-center border border-dark rounded-xl">
                <div class="cta-2">{{satisfaction}}%</div>
              </div>
              
            </div>
            <div class="col sh-6 ps-3 d-flex flex-column justify-content-center">
              <div class="heading mb-0 d-flex align-items-center">Satisfaction</div>
              <div class="text-small text-muted text">SUR LES 30 DERNIERS JOURS</div>
            </div>
            <div class="progress progress-lg mt-4">
              <progress class="progress" :value="satisfaction" max="100">15%</progress>
            </div>
          </div>
          
        </div>
        
      </div>
      
    </div>
  </div>
  </div>
</template>


<script>
export default {
  props: {
    establishment: Object
  },
  computed: {
    satisfaction() {
      let ret = 0;
      const nbNegative = parseInt(this.establishment.nb_negative);
      const nbPositive = parseInt(this.establishment.nb_positive);
      if (nbNegative + nbPositive > 0) {
        ret = Math.round(100 * nbPositive / (nbPositive + nbNegative));
      }
      return ret;
    }
  }
};
</script>
